import { useLoading } from '../context/LoadingContext';
import { Spin } from './Ant';

const GlobalLoader = () => {
  const { isLoading } = useLoading();

  if (!isLoading) return null;

  return <Spin data-testid="load-panel" fullscreen />;
};

export default GlobalLoader;
